module.exports = __webpack_public_path__ + "img/36.698c295e.jpg";